export default {"src":"/evde-internet/_next/static/media/desktop-linkat-ill.f8871b0f.svg","height":224,"width":333};